module.exports = __webpack_public_path__ + "static/img/img2_en.5769cf2e.png";